<section class="wrap-loader" *ngIf="showIntermediateLoader || showLoader">
  <div class="loader">{{loaderText}}
  </div>
</section>